import api from "../utils/axiosInstance";

const API = "support";


export const createTicket = async (data) => {
  try {
    const response = await api.post(`/${API}/create`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTickets = async (page) => {
  try {
    const data = {
      page: page
    }
    const response = await api.post(`/${API}/gettickets`, data);
    return response;
  } catch (error) {
    return error;
  }
};


export const createChat = async (data) => {
  try {
    const response = await api.post(`/${API}/createchat`, data);
    return response;
  } catch (error) {
    return error;
  }
};


export const getChats = async (data) => {
  const id = {
    ticketId: data
  }
  try {
    const response = await api.post(`/${API}/getchat`, id);
    return response;
  } catch (error) {
    return error;
  }
};

export const createSocket = async (data) => {

  try {
    const response = await api.post(`/${API}/start-socket`, null);
    return response;
  } catch (error) {
    return error;
  }
};

export const closeTicket = async (data) => {
  try {
    const response = await api.post(`/${API}/closeticket`, data);
    return response;
  } catch (error) {
    return error;
  }
};









